import React, { useContext } from "react";
import {
    FileUploadContext,
    PRICES,
    DESIGN_FILE,
    EXTENDED_CONTROL
} from "../../../../Providers/FileUploadProvider/FileUploadProvider";
import Modal from "../../../../UX/Modal/Modal";
import FileUploadContainer from "./FileUploadContainer";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import accounting from "accounting";

const FileUploadModal = () => {
    const {
        showModal,
        onHideUploadModal,
        extraOption,
        onSelectExtraOption
    } = useContext(FileUploadContext);
    const { productName, steps, selectedOption } = useContext(
        ProductOptionStepsContext
    );
    return (
        <>
            <Modal
                size="large"
                onClose={onHideUploadModal}
                display={showModal}
                title={
                    <h4>
                        Bestanden uploaden voor: {productName}{" "}
                        {selectedOption
                            ? "(" + selectedOption.qty + " stuks)"
                            : ""}
                    </h4>
                }
                //loadText={"Informatie aan het ophalen"}
                footer={[
                    <button
                        key={1}
                        onClick={onHideUploadModal}
                        className="bg-blue-500 text-white px-4 py-2 text-white rounded mr-2 font-bold hover:bg-blue-600 text-sm"
                    >
                        Doorgaan met bestelling
                    </button>
                ]}
            >
                <div className="w-full">
                    <div className="w-full">
                        <FileUploadContainer />
                    </div>
                    <div className="w-full">
                        <p className="font-bold mb-1">Extra bestandsopties</p>
                        <p className="text-sm mb-4">
                            Standaard controleren wij altijd of het formaat, de resolutie en de aanwezigheid van snijmarge/afloop correct is. <br />
                            Als je wilt dat we het bestand controleren op kleurinstellingen, overdruk of transparantie kan je de ‘uitgebreide bestandscontrole’ selecteren.<br />
                            Wil je aanpassingen maken in het ontwerp? Zoals tekst, kleur of vervanging van plaatjes/logo’s. Dan kun je ‘bestand laten opmaken’ selecteren.
                        </p>
                        <input
                            onChange={e => onSelectExtraOption(e.target.value)}
                            checked={
                                extraOption === EXTENDED_CONTROL
                                    ? "checked"
                                    : false
                            }
                            type="checkbox"
                            name="extra_file_option"
                            value={EXTENDED_CONTROL}
                            id={EXTENDED_CONTROL}
                            className="mr-1 align-middle"
                            required
                        />
                        <label htmlFor={EXTENDED_CONTROL} className="mr-4 align-text-top">
                            Uitgebreide bestands controle (+ € {accounting.formatMoney(
                            PRICES[EXTENDED_CONTROL],
                            "",
                            2,
                            ".",
                            ","
                        )} excl. btw)
                        </label>
                        <input
                            onChange={e => onSelectExtraOption(e.target.value)}
                            checked={
                                extraOption === DESIGN_FILE ? "checked" : false
                            }
                            type="checkbox"
                            name="extra_file_option"
                            value={DESIGN_FILE}
                            id={DESIGN_FILE}
                            required
                            className="mr-1 align-middle"
                        />
                        <label htmlFor={DESIGN_FILE} className="align-text-top">
                            Bestand laten opmaken (+ € {accounting.formatMoney(
                            PRICES[DESIGN_FILE],
                            "",
                            2,
                            ".",
                            ","
                        )} excl. btw per kwartier)
                        </label>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default FileUploadModal;
